import isNumber from 'lodash/isNumber';

function validateWeightHeight(caseConf) {
  const errors = [];
  if (
    caseConf.measurementSystem &&
    !isNumber(caseConf.initialConditions.weight) &&
    !isNumber(caseConf.initialConditions.height)
  ) {
    errors.push(
      measurementSystemError(
        'You need to input Patient Height or Patient Weight if Measurement Units are selected'
      )
    );
  }

  if (
    !caseConf.measurementSystem &&
    (isNumber(caseConf.initialConditions.weight) ||
      isNumber(caseConf.initialConditions.height))
  ) {
    errors.push(
      measurementSystemError(
        'You need to select Measurement Units if Patient Height or Patient Weight is input'
      )
    );
  }

  return {
    errors,
    warnings: [],
  };
}

function measurementSystemError(message) {
  return {
    message,
    category: 'patientConditions',
    field: 'measurementSystem',
    metadata: {},
  };
}

export default validateWeightHeight;
